<template>
  <section class="inventory--part-details animated fadeIn">
    <div class="list-group-item mb-2">
      <b-form-radio-group :options="['Yes', 'No', 'N/A']" v-model="model.qcMgmt_BlankProgramCheck">
        <span class="col-form-label">Did you test the chips for previous programming or conduct a blank check on the device? What is the result?</span>
      </b-form-radio-group>
      <b-form-group label="Results" label-align="right" label-cols-sm="1">
        <b-form-input type="text" class="col-4" v-model="model.qcMgmt_BPCResults"></b-form-input>
      </b-form-group>
      <b-form-radio-group :options="['Yes', 'No', 'N/A']" v-model="model.qcMgmt_XRay">
        <span class="col-form-label">Did you X-Ray the parts? What is the result?</span>
      </b-form-radio-group>
      <b-form-group label="Results" label-align="right" label-cols-sm="1">
        <b-form-input type="text" class="col-4" v-model="model.qcMgmt_XRayResults"></b-form-input>
      </b-form-group>
      <b-form-radio-group :options="['Yes', 'No', 'N/A']" v-model="model.qcMgmt_ChemTest">
        <span class="col-form-label">Did you conduct a chemical swab test? What is the result.</span>
      </b-form-radio-group>
      <b-form-group label="Results" label-align="right" label-cols-sm="1">
        <b-form-input type="text" class="col-4" v-model="model.qcMgmt_ChemTestResults"></b-form-input>
      </b-form-group>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {FIELDS}  from '../../constants'
export default {
  name: 'aegisQcManagement',
  components: {},
  props: {
    inspectionDetails: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      model: {
        qcMgmt_BlankProgramCheck: this.inspectionDetails[FIELDS.QCMGMT__BLANK_PROGRAM_CHECK] || '',
        qcMgmt_BPCResults: this.inspectionDetails[FIELDS.QCMGMT__BPCRESULTS] || '',
        qcMgmt_XRay: this.inspectionDetails[FIELDS.QCMGMT__XRAY] || '',
        qcMgmt_XRayResults: this.inspectionDetails[FIELDS.QCMGMT__XRAY_RESULTS] || '',
        qcMgmt_ChemTest: this.inspectionDetails[FIELDS.QCMGMT__CHEM_TEST] || '',
        qcMgmt_ChemTestResults: this.inspectionDetails[FIELDS.QCMGMT__CHEM_TEST_RESULTS] || '',
      },
    };
  },
  computed: {},
  mounted() {},
};
</script>